module.exports = __webpack_public_path__ + "static/pinweichangan-ce5d2368c5394d36e5811d3f4018eb01.png";